export type ViewMode =
  | {
      type: '2D';
    }
  | {
      type: '3D';
    }
  | {
      type: 'Panorama';
    }
  | {
      type: 'Image';
      cameraIndex: number;
    };

export function viewModeEquals(
  prev: ViewMode | undefined,
  next: ViewMode | undefined
): boolean {
  if (prev === undefined || next === undefined) return prev === next;
  if (prev.type !== next.type) return false;

  if (prev.type === 'Image' && next.type === 'Image') {
    return prev.cameraIndex === next.cameraIndex;
  }

  return true;
}
